import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * CRM Module Service Stores
 * Updated to match backend api-types
 */
export const crmStores: ServiceStoreConfig[] = [
  // NOTE: the old bare `customers`, `customer-satisfaction`, and `vendors`
  // configs were removed — the API de-registered those services and dropped
  // their tables when @intrasync/accounting was installed (services/index.ts
  // "superseded by @intrasync/accounting-api"). Keeping the configs only
  // produced "Service 'customers'/'vendors' not found" toasts on every find.
  // Customers/vendors now come from the accounting module (eager-mounted
  // accountingCustomersStore / accountingVendorsStore) via the bare->namespaced
  // alias getters in stores/RootStore.ts.
  {
    name: "vendor-performance",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: true,
        actions: {
          enableInlineEdit: true,
          enableRemove: true,
        },
        summaryCards: (rootStore) => {
          const store = rootStore.vendorPerformanceStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalReviews = entities.length;
          const averageScore = entities.length > 0
            ? entities.reduce((sum: number, review: Record<string, unknown>) => sum + ((review.performanceScore as number) || 0), 0) / entities.length
            : 0;
          const topPerformers = entities.filter(
            (review: Record<string, unknown>) => (review.performanceScore as number) >= 4.5
          ).length;
          const underperformers = entities.filter(
            (review: Record<string, unknown>) => (review.performanceScore as number) < 3.0
          ).length;

          return [
            {
              title: "Total Reviews",
              value: () => totalReviews.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Average Score",
              value: () => averageScore.toFixed(2),
              valueColor: "info.main",
            },
            {
              title: "Top Performers (4.5+)",
              value: () => topPerformers.toString(),
              valueColor: "success.main",
            },
            {
              title: "Under 3.0",
              value: () => underperformers.toString(),
              valueColor: "error.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
];
